import React from 'react';

interface ComparisonIconProps {
  style?: React.CSSProperties;
}

const ComparisonIcon: React.FC<ComparisonIconProps> = ({ style }) => {
  return (
    <svg style={style} viewBox="0 0 26 30">
      <title>Comparison</title>
      <path d="M6.495 18.75L0 15v7.5l6.495 3.75v-7.5z" fill="#FD9D52" />
      <path d="M12.99 0L6.495 3.75 12.99 7.5l6.495-3.75L12.99 0z" fill="#943CFF" />
      <path d="M6.495 3.75L0 7.5V15l6.495 3.75L12.99 15V7.5L6.495 3.75z" fill="#DD45D3" />
      <path d="M25.98 7.5l-6.495-3.75L12.99 7.5V15l6.495 3.75L25.98 15V7.5z" fill="#FD9D52" />
      <path d="M19.485 18.75v7.5l6.495-3.75V15l-6.495 3.75z" fill="#DD45D3" />
      <path d="M12.99 15l-6.495 3.75v7.5L12.99 30l6.495-3.75v-7.5L12.99 15z" fill="#943CFF" />
    </svg>
  );
};

export default ComparisonIcon;
